import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { DatePipe } from '@angular/common';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import * as XLSX from 'xlsx';//CDPJ
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { UploadfilesService } from '../../advantage/advantageservices/uploadfiles.service';

import { InvenclispreService } from "../invservicios/invenclispre.service";
import { Invdetlispre } from "../invinterfaces/invdetlispre";
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-invenclispre',
  templateUrl: './invenclispre.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class InvenclispreComponent implements OnInit {

  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef

  indicador: any;
  permisoEnclispre: SegMaePermiso;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;

  public frameworkComponents;
  rowSelection = 'multiple';
  defaultDetlispre;
  rowStyle;
  largo: string;
  detlispreSelected: Invdetlispre;
  index = 0;
  spin
  datosJson;

  displayDialogBusquedaFast: boolean;
  types: SelectItem[];
  busquedacampos: any[];
  tabla: string;
  consulta: string;
  arregloCons: any[];
  arregloBus: any[];
  where: string;
  opcion: string;
  lblbestado:string;

    // autorizacion
    claveAuth: string;
    autorizacionCodigo: string;
    bolAutorizacion: boolean;
    displayDialogAutorizacion: boolean;
    
  columnDefsDetlispre = [
    {
      headerName: 'Art. Código', field: 'ART_CODIGO',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 130, cellStyle: { textAlign: 'left' }
    },
    {
      headerName: 'Art. Nombre', field: 'ART_NOMBRE',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 280, cellStyle: { textAlign: 'left' }
    },
    {
      headerName: 'Código', field: 'DETLISPRE_CODIGO',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'left' }
    },
    {
      headerName: 'Precio', field: 'DETLISPRE_PRECIO',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'right' }
    },
    {
      headerName: 'Costo', field: 'DETLISPRE_COSTO',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'right' }
    },
    {
      headerName: 'Descuento %', field: 'DETLISPRE_DESCUENTO',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 120, cellStyle: { textAlign: 'right' }
    },
    {
      headerName: 'Utilidad%', field: 'DETLISPRE_PORCENTAJE',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 120, cellStyle: { textAlign: 'right' }
    },
  ]
  constructor(
    public invenclispreService: InvenclispreService,
    public init: NuevoComponentService, private initConf: ConfInicialesService,
    private busquedaSer: InvbusquedaService, private datePipe: DatePipe, private permisosService: PermisosService,
    private messageService: MessageService, private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    public uploadFileService: UploadfilesService,
  ) {
    this.agTable();
  }

  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.rowStyle = (params) => {
      if (params.data.COLOREXISTEDOC === 'Y') {
        return { background: 'rgb(245,236,166)' };
      }
    };
    this.defaultDetlispre = {
      editable: true,
      objeto: 'detlispre',
      resizable: true
    };
  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    //console.log(this.indicador)
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;

    this.invenclispreService.enclispre[this.indicador] = {};
    this.invenclispreService.detlispre = [];
    this.lblbestado='';
    await this.getPermisos();
    const respuesta: any = await this.initConf.getDecimalesP('frmINV_MAEARTICULO');
    

    this.invenclispreService.configDecimales = respuesta;
    
   
    this.spin = false;

    //console.log(this.encfacService.encfacarray[this.indicador])

    this.detlispreSelected = {};
    this.largo = '-5800';

  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoEnclispre = data[0];
        } else {
          this.permisoEnclispre = null;
        }
      } else {
        this.permisoEnclispre = null;
      }
    } catch (e) {
      this.permisoEnclispre = null;
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  manejarSenales(valor) {
    if (valor === 'Nuevo') {
      if (this.permisoEnclispre.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoEnclispre.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisoEnclispre.PERTODO === 1) {
        this.validarGuardar();
      } else {
        if (this.permisoEnclispre.PERINSERCION === 1) {
          this.validarGuardar();
        } else {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada'
          });
        }
      }
    }
    if (valor === 'Buscar') {
      if (this.permisoEnclispre.PERTODO === 1) {
        this.busqueda();
      } else {
        if (this.permisoEnclispre.PERSELECCION === 1) {
          this.busqueda();
        } else {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos para consultar, acción denegada'
          });
        }
      }
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
    if (valor === 'Descargar') {
      this.descargarDemo()
    }
    if (valor === 'Actlispre') {
      if (this.botonGuardar === false) {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'Primero debe guardar la lista de precios'
        });
        return
      }
      if (this.invenclispreService.enclispre[this.indicador].ENCLISPRE_ESTADO === 'P') {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'Primero autorice el documento'
        });
        return
      }
      this.actualizarlispre();
    }
    if (valor === 'Borrar') {
      if (this.permisoEnclispre.PERTODO === 1) {

        this.borrar();
      } else {
        if (this.permisoEnclispre.PERELIMACION === 1) {

          this.borrar();
        } else {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }
      }
    }
    if(valor === 'Autorizar'){
      if (this.permisoEnclispre.PERTODO === 0) {
        if (this.permisoEnclispre.PERINSERCION === 0 && this.permisoEnclispre.PERACTUALIZACION === 0) {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción ni de actualización, Consulte con el Administrador del Sistema.'
          });
          return;
        }
        if (this.permisoEnclispre.PERSELECCION === 1 && this.permisoEnclispre.PERINSERCION === 0 && this.permisoEnclispre.PERACTUALIZACION === 0) {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario solo tiene permisos para consultar, Consulte con el Administrador del Sistema.'
          });
          return;
        }
      }
      if (this.invenclispreService.enclispre[this.indicador].ENCLISPRE_ESTADO === 'O') {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'El documento ya fue procesado'
        });
        return;
      }
      this.autlisprecio()
    }
    if (valor === 'Cancelar') {
      this.cancelar();
    }
  }
  autlisprecio(){
    this.claveAuth = '';
    this.autorizacionCodigo = '';
    this.displayDialogAutorizacion = true;
  }
  comprobarClave() {
    this.invenclispreService.obtenerClave(this.autorizacionCodigo).subscribe(async (clave) => {
      let claveReal;
      claveReal = clave[0].AUTORIZACION_CLAVE;
      if (claveReal === this.claveAuth) {
        //this.accionesAutorizacion();
        this.botonesmodificar();
        this.invenclispreService.enclispre[this.indicador].ENCLISPRE_ESTADO='A';
        this.lblbestado='AUTORIZADO';
        this.displayDialogAutorizacion=false
        await this.auditoriagral.registrarAuditoria('INV_ENCLISPRE', 'AUTORIZACION/'+this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO, 'A', '', '01', '', '', '', '').toPromise();
      } else if (clave !== this.claveAuth) {
        this.messageService.add({
          key: 'autorizacion',
          severity: 'error',
          summary: 'Clave Autorización',
          detail: 'La clave que se ingresó es incorrecta, intente nuevamente'
        });
      }
    });
  }
  async borrar() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'enclispreconf',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          let numero = this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO;
          this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO = '';

          await this.invenclispreService.borrarRegistro(numero)
          await this.auditoriagral.registrarAuditoria('INV_ENCLISPRE', numero, 'E', '', '01', '', '', '', '').toPromise();
          await this.cancelar();

          this.messageService.add({
            key: 'invenclispre',
            severity: 'success',
            summary: 'Información',
            detail: 'El registro se eliminó de forma correcta'
          });

        } catch (error) {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un error durante la eliminación ' + error.error
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async actualizarlispre() {
    try {
      this.spin = true;
      let numero = this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO
      if (isNullOrUndefined(numero) || numero === '') {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'Primero guarde la lista de precios'
        });
        this.spin = false;
        return;
      }
      if (this.invenclispreService.detlispre.length === 0) {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'El detalle no puede estar vacío'
        });
        this.spin = false;
        return;
      }
      await this.finactlispre()
    } catch (error) {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar ' + error.error
      });
      this.spin = false;
      return;
    }
  }
  async finactlispre() {
    try {
      await this.invenclispreService.actualizalispre(this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO)
      await this.auditoriagral.registrarAuditoria('INV_ENCLISPRE',
        this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO + '/BOTON-ACT-LISTA-PRECIOS', 'A', '', '01', '', '', '', '').toPromise();
      await  this.encontrarregistro(this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO)
      this.spin = false;
      this.messageService.add({
        key: 'invenclispre',
        severity: 'success',
        summary: 'Información',
        detail: 'Lista de precios actualizada exitosamente'
      });
    } catch (error) {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al actualizar' + error.error
      });
      this.spin = false;

    }
  }
  busqueda() {
    this.opcion = 'BUSCARREG';
    this.types = [
      { label: 'Número', value: 'ENCLISPRE_NUMERO' },
      { label: 'FECHA', value: 'ENCLISPRE_FECHA' },
      { label: 'Concepto', value: 'ENCLISPRE_CONCEPTO' },
      { label: 'Estado', value: 'ENCLISPRE_ESTADO' },

    ];
    this.busquedacampos = ['', '', '',''];
    this.tabla = 'INV_ENCLISPRE';
    this.where = ' ENCLISPRE_NUMERO is not null order by 1 desc';
    this.busquedaSer.busquedaRegINVenclispre().subscribe((res: any[]) => {
      if (res !== null) {
        this.arregloCons = res;
        this.arregloCons.map((dato) => {
          if (dato.ENCLISPRE_FECHA !== null) {
            dato.ENCLISPRE_FECHA = this.datePipe.transform(dato.ENCLISPRE_FECHA, 'dd/MM/yyyy');
          } else {
            dato.ENCLISPRE_FECHA = '';
          }
        });
        this.displayDialogBusquedaFast = true;

      }

    });
  }
  async descargarDemo() {
    try {
      const rs: any = await this.uploadFileService.getDocument('LISTA_PRECIOS_DEMO.xlsx');
      this.downloadDocument(rs.respuesta, 'LISTA_PRECIOS_DEMO.xlsx');
    } catch (err) {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrio un error al encontrar el archivo' + err.error
      });
    }
  }
  manejarSeleccion(opcion) {
    if (this.opcion === 'BUSCARREG') {
      this.encontrarregistro(opcion.ENCLISPRE_NUMERO)
    }
    this.displayDialogBusquedaFast = false;
  }
  downloadDocument(strBase64, filename) {
    const byteCharacters = atob(strBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const data = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 1000)
  }
  validarGuardar() {
    this.spin = true;
    const acc: any = {}
    for (const item of this.invenclispreService.detlispre) {
      const key = String(item.ART_CODIGO).trim() + '-' + String(item.DETLISPRE_CODIGO).trim()
      if (!acc[key]) {
        acc[key] = {
          ARTCODIGO: item.ART_CODIGO,
          LISTACOD: item.DETLISPRE_CODIGO,
          CANTIDAD: 0
        }

      }
      acc[key].CANTIDAD++
    }
    const result = Object.values(acc) as any[]
    for (const iterator of result) {
      if (iterator.CANTIDAD > 1) {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Error',
          detail: 'El artículo ' + iterator.ARTCODIGO + ', con la lista de precio ' + iterator.LISTACOD + ', está repetido, por favor revisar'
        });
        this.spin = false//CDPJ
        return;
      }
    }
    if (isNullOrUndefined(this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA) ||
      this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA === '') {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'La fecha no puede estar vacía'
      });
      this.spin = false;
      return;

    }
    if (isNullOrUndefined(this.invenclispreService.enclispre[this.indicador].ENCLISPRE_CONCEPTO) ||
      this.invenclispreService.enclispre[this.indicador].ENCLISPRE_CONCEPTO === '') {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'El concepto no puede estar vacío'
      });
      this.spin = false;
      return;
    }
    if (this.invenclispreService.detlispre.length === 0) {

      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'El detalle no puede estar vacío'
      });
      this.spin = false;
      return;
    }
    this.finguardar()
  }
  async finguardar() {
    try {
      let numero = this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO
      if (isNullOrUndefined(numero) || numero === '') {
        if (this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA.toString().includes('-')) {
          this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA = this.datePipe.transform(this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA, 'dd/MM/yyyy')
        }
        const data = await this.invenclispreService.insertaenclispre(this.invenclispreService.enclispre[this.indicador])
        if (data.length > 0 && data !== null) {
          for (const item of data) {
            this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO = item.ENCLISPRE_NUMERO
            await this.auditoriagral.registrarAuditoria('INV_ENCLISPRE',
              item.ENCLISPRE_NUMERO + '/' + this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA
              + '/' + this.invenclispreService.enclispre[this.indicador].ENCLISPRE_CONCEPTO, 'I', '', '01', '', '', '', '').toPromise();
            for (const iterator of this.invenclispreService.detlispre) {
              if (iterator.LINEA === 0) {
                iterator.ENCLISPRE_NUMERO = item.ENCLISPRE_NUMERO
                iterator.DETLISPRE_PRECIO = Number(iterator.DETLISPRE_PRECIO);
                iterator.DETLISPRE_DESCUENTO = Number(iterator.DETLISPRE_DESCUENTO);
                iterator.DETLISPRE_PORCENTAJE = Number(iterator.DETLISPRE_PORCENTAJE);
                iterator.DETLISPRE_COSTO = Number(iterator.DETLISPRE_COSTO)
                await this.invenclispreService.insertadetlispre(iterator)
                await this.auditoriagral.registrarAuditoria('INV_DETLISPRE',
                  iterator.ENCLISPRE_NUMERO + '/' + iterator.ART_CODIGO + '/' + iterator.DETLISPRE_CODIGO + '/' + iterator.DETLISPRE_PRECIO + '/' + iterator.DETLISPRE_COSTO +
                  '/' + iterator.DETLISPRE_DESCUENTO
                  , 'I', '', '01', '', '', '', '').toPromise();
              } else {
                iterator.ENCLISPRE_NUMERO = item.ENCLISPRE_NUMERO
                iterator.DETLISPRE_PRECIO = Number(iterator.DETLISPRE_PRECIO);
                iterator.DETLISPRE_DESCUENTO = Number(iterator.DETLISPRE_DESCUENTO);
                iterator.DETLISPRE_PORCENTAJE = Number(iterator.DETLISPRE_PORCENTAJE);
                iterator.DETLISPRE_COSTO = Number(iterator.DETLISPRE_COSTO)
                await this.invenclispreService.insertadetlispre(iterator)
                await this.auditoriagral.registrarAuditoria('INV_DETLISPRE',
                  iterator.ENCLISPRE_NUMERO + '/' + iterator.ART_CODIGO + '/' + iterator.DETLISPRE_CODIGO + '/' + iterator.DETLISPRE_PRECIO + '/' + iterator.DETLISPRE_COSTO +
                  '/' + iterator.DETLISPRE_DESCUENTO
                  , 'A', '', '01', '', '', '', '').toPromise();
              }
            }
          }
          await this.cancelar();
          this.spin = false;
          this.messageService.add({
            key: 'invenclispre',
            severity: 'success',
            summary: 'Información',
            detail: 'Lista guardada exitosamente'
          });
        }
      } else {
        if (this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA.toString().includes('-')) {
          this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA = this.datePipe.transform(this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA, 'dd/MM/yyyy')
        }
        const data = await this.invenclispreService.insertaenclispre(this.invenclispreService.enclispre[this.indicador])
        if (data.length > 0 && data !== null) {
          for (const item of data) {
            this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO = item.ENCLISPRE_NUMERO
            await this.auditoriagral.registrarAuditoria('INV_ENCLISPRE',
              item.ENCLISPRE_NUMERO + '/' + this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA
              + '/' + this.invenclispreService.enclispre[this.indicador].ENCLISPRE_CONCEPTO, 'A', '', '01', '', '', '', '').toPromise();
            for (const iterator of this.invenclispreService.detlispre) {
              if (iterator.LINEA === 0) {
                iterator.ENCLISPRE_NUMERO = item.ENCLISPRE_NUMERO
                iterator.DETLISPRE_PRECIO = Number(iterator.DETLISPRE_PRECIO);
                iterator.DETLISPRE_DESCUENTO = Number(iterator.DETLISPRE_DESCUENTO);
                iterator.DETLISPRE_PORCENTAJE = Number(iterator.DETLISPRE_PORCENTAJE);
                iterator.DETLISPRE_COSTO = Number(iterator.DETLISPRE_COSTO)
                await this.invenclispreService.insertadetlispre(iterator)
                await this.auditoriagral.registrarAuditoria('INV_DETLISPRE',
                  iterator.ENCLISPRE_NUMERO + '/' + iterator.ART_CODIGO + '/' + iterator.DETLISPRE_CODIGO + '/' + iterator.DETLISPRE_PRECIO + '/' + iterator.DETLISPRE_COSTO +
                  '/' + iterator.DETLISPRE_DESCUENTO
                  , 'I', '', '01', '', '', '', '').toPromise();
              } else {
                iterator.ENCLISPRE_NUMERO = item.ENCLISPRE_NUMERO
                iterator.DETLISPRE_PRECIO = Number(iterator.DETLISPRE_PRECIO);
                iterator.DETLISPRE_DESCUENTO = Number(iterator.DETLISPRE_DESCUENTO);
                iterator.DETLISPRE_PORCENTAJE = Number(iterator.DETLISPRE_PORCENTAJE);
                iterator.DETLISPRE_COSTO = Number(iterator.DETLISPRE_COSTO)
                await this.invenclispreService.insertadetlispre(iterator)
                await this.auditoriagral.registrarAuditoria('INV_DETLISPRE',
                  iterator.ENCLISPRE_NUMERO + '/' + iterator.ART_CODIGO + '/' + iterator.DETLISPRE_CODIGO + '/' + iterator.DETLISPRE_PRECIO + '/' + iterator.DETLISPRE_COSTO +
                  '/' + iterator.DETLISPRE_DESCUENTO
                  , 'A', '', '01', '', '', '', '').toPromise();
              }
            }
          }
          await this.cancelar();
          this.spin = false;
          this.messageService.add({
            key: 'invenclispre',
            severity: 'success',
            summary: 'Información',
            detail: 'Lista actualizada exitosamente'
          });
        }

      }
    } catch (error) {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al guardar la información ' + error.error
      });
    }
  }
  nuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.lblbestado='PENDIENTE';

    this.invenclispreService.enclispre[this.indicador] = {
      ENCLISPRE_NUMERO: '',
      COM_CODIGO: '01',
      ENCLISPRE_CONCEPTO: '',
      ENCLISPRE_FECHA: new Date(),
      ENCLISPRE_ESTADO:'P'

    }
    this.invenclispreService.detlispre = [];
    this.detlispreSelected = {}
    document.getElementById('contorno').style.pointerEvents = 'all';
    document.getElementById('ENCLISPRE_CONCEPTO').focus();
  }

  cancelar() {
    let numero = this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO
    if (isNullOrUndefined(numero) || numero == '') {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.invenclispreService.enclispre[this.indicador] = {};
      this.invenclispreService.detlispre = [];
      this.detlispreSelected = {};
      this.lblbestado='';

      document.getElementById('contorno').style.pointerEvents = 'none';

    } else {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.invenclispreService.enclispre[this.indicador] = {};
      this.invenclispreService.detlispre = [];
      this.detlispreSelected = {};
      this.encontrarregistro(numero)
    }
  }
  async encontrarregistro(numero) {
    try {
      const data = await this.invenclispreService.getenclispre(numero)

      if (data.length > 0 && data !== null) {
        const data2 = await this.invenclispreService.getdetlispre(numero)
        this.invenclispreService.detlispre=[]
        for (const iterator of data) {
          iterator.ENCLISPRE_FECHA = new Date(iterator.ENCLISPRE_FECHA)
          iterator.ENCLISPRE_ESTADO=isNullOrUndefined(iterator.ENCLISPRE_ESTADO)?'P':iterator.ENCLISPRE_ESTADO
          this.lblbestado=iterator.ENCLISPRE_ESTADO === 'P'? 'PENDIENTE':iterator.ENCLISPRE_ESTADO === 'A'?'AUTORIZADO':iterator.ENCLISPRE_ESTADO === 'O'?'PROCESADO':'';

          this.invenclispreService.enclispre[this.indicador] = iterator
        }
        if (data2.length > 0 && data2 !== null) {
          let linea = 1;
          for (const item of data2) {
            item.DETLISPRE_PRECIO = Number(item.DETLISPRE_PRECIO).toFixed(this.invenclispreService.obtenerConfig('PRECIO', 'MaePrecio'));
            item.DETLISPRE_COSTO = Number(item.DETLISPRE_COSTO).toFixed(this.invenclispreService.obtenerConfig('COSTO', 'MaePrecio'));
            item.DETLISPRE_PORCENTAJE = Number(item.DETLISPRE_PORCENTAJE).toFixed(2);
            item.DETLISPRE_DESCUENTO = Number(item.DETLISPRE_DESCUENTO).toFixed(2);
            item.LINEA = linea
            this.invenclispreService.detlispre.push(item)
            linea++
          }
        }
        this.aggrid.refreshaggrid(this.invenclispreService.detlispre, this.defaultDetlispre.objeto);
        document.getElementById('contorno').style.pointerEvents = 'all';
        if (this.invenclispreService.enclispre[this.indicador].ENCLISPRE_ESTADO === 'O') {
          document.getElementById('contorno').style.pointerEvents = 'none';
        }
        
      }
    } catch (error) {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar la información' + error.error
      });
    }
  }
  setFocus(evento) {

  }
  botonesmodificar() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
  }
  cambio(evento) {

  }
  seleccionDetlispre(params) {
    if (params === 'subirxls') {
      if (this.invenclispreService.enclispre[this.indicador].ENCLISPRE_ESTADO === 'O') {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'El documento debe estar en estado pendiente'
        });
        return;
      }
      if (isNullOrUndefined(this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA) || this.invenclispreService.enclispre[this.indicador].ENCLISPRE_FECHA === '') {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'La fecha no puedes estar vacía'
        });
        return;
      }
      this.inputfile.nativeElement.click();
      return;
    }

    if (params === 'eliminar') {
      if (this.invenclispreService.enclispre[this.indicador].ENCLISPRE_ESTADO === 'O') {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'El documento debe estar en estado pendiente o autorizado'
        });
        return;
      }
      if (isNullOrUndefined(this.detlispreSelected) || Object.entries(this.detlispreSelected).length === 0) {
        this.messageService.add({
          key: 'invenclispre',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleecionar un registro'
        });
        return;
      }
      this.confirmeliminaregistro()
      return
    }
    if (params.object !== undefined) {
      this.detlispreSelected = params.object;
    }
  }
  confirmeliminaregistro() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'enclispreconf',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {

          if (this.detlispreSelected.LINEA === 0) {
            this.invenclispreService.detlispre = this.invenclispreService.detlispre.filter((val, j) => j !==
              this.invenclispreService.detlispre.indexOf(this.detlispreSelected));

            this.aggrid.refreshaggrid(this.invenclispreService.detlispre, this.defaultDetlispre.objeto);
            this.messageService.add({
              key: 'invenclispre',
              severity: 'success',
              summary: 'Información',
              detail: 'El registro se eliminó de forma correcta'
            });
          } else {
            await this.invenclispreService.eliminadetregistro(this.detlispreSelected);

            await this.auditoriagral.registrarAuditoria('INV_DETLISPRE',
              this.detlispreSelected.ENCLISPRE_NUMERO + '/' + this.detlispreSelected.ART_CODIGO + '/' + this.detlispreSelected.DETLISPRE_CODIGO +
              '/' + this.detlispreSelected.DETLISPRE_PRECIO + '/' + this.detlispreSelected.DETLISPRE_COSTO +
              '/' + this.detlispreSelected.DETLISPRE_DESCUENTO
              , 'E', '', '01', '', '', '', '').toPromise();

            this.invenclispreService.detlispre = this.invenclispreService.detlispre.filter((val, j) => j !==
              this.invenclispreService.detlispre.indexOf(this.detlispreSelected));

            this.aggrid.refreshaggrid(this.invenclispreService.detlispre, this.defaultDetlispre.objeto);
            this.messageService.add({
              key: 'invenclispre',
              severity: 'success',
              summary: 'Información',
              detail: 'El registro se eliminó de forma correcta'
            });
          }

        } catch (error) {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un error durante la eliminación ' + error.error
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async onBasicUpload(ev) {
    let validacionVacio = true;
    console.log(ev[0]);
    console.log(ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellDates: true, cellNF: false, cellText: false });

      jsonData = workBook.SheetNames.reduce((initial, name) => {
        console.log(workBook.Sheets[name]);
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        return initial;
      }, {});
      console.log(jsonData.Hoja1);

      for (let data of jsonData.Hoja1) {

        delete data.__EMPTY;
        for (let key in data) { // se revisa los campos del json generado del excel,
          // si uno de esos campos no existe o está vacío no se activará el boton de guardar
          if (data[key] === '') {
            validacionVacio = false;
          }

        }
      }
      this.datosJson = jsonData.Hoja1;
      console.log(this.datosJson)
      this.inputfile.nativeElement.value = ''

      await this.validaexcell();

    }
    reader.readAsBinaryString(file);
  }
  async validaexcell() {
    try {
      this.spin = true
      const artcod = Array.from(new Set(this.datosJson.map(item =>
        item.ARTCODIGO.toString()).filter(x => x !== null && String(x).trim() !== '')))

      const listacod = Array.from(new Set(this.datosJson.map(item =>
        item.LISTACOD.toString()).filter(x => x !== null && String(x).trim() !== '')))

      const acc: any = {}
      for (const item of this.datosJson) {
        const key = String(item.ARTCODIGO).trim() + '-' + String(item.LISTACOD).trim()
        if (!acc[key]) {
          acc[key] = {
            ARTCODIGO: item.ARTCODIGO,
            LISTACOD: item.LISTACOD,
            CANTIDAD: 0
          }

        }
        acc[key].CANTIDAD++
      }
      const result = Object.values(acc) as any[]

      const rsart = await this.invenclispreService.validaartcod(artcod)
      const rslistacod = await this.invenclispreService.validalistacod(listacod)
      if (rsart !== null && rsart !== undefined) {
        if (rsart.length > 0) {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Error',
            detail: 'No existen los siguientes artículos: ' + rsart.join(", ") + ' o no están activados'
          });
          this.spin = false//CDPJ
          return;
        }
      }
      if (rslistacod !== null && rslistacod !== undefined) {
        if (rslistacod.length > 0) {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Error',
            detail: 'No existen los siguientes listas de precios: ' + rslistacod.join(", ") + '. En referencias, por favor revisar'
          });
          this.spin = false//CDPJ
          return;
        }
      }
      for (const iterator of result) {
        if (iterator.CANTIDAD > 1) {
          this.messageService.add({
            key: 'invenclispre',
            severity: 'error',
            summary: 'Error',
            detail: 'El artículo ' + iterator.ARTCODIGO + ', con la lista de precio ' + iterator.LISTACOD + ', está repetido, por favor revisar'
          });
          this.spin = false//CDPJ
          return;
        }
      }


      this.cargardetalle()
    } catch (error) {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar los datos ' + error
      });
      this.spin = false//CDPJ
      return;
    }
  }
  cargardetalle() {
    try {
      let numero = this.invenclispreService.enclispre[this.indicador].ENCLISPRE_NUMERO
      for (const iterator of this.datosJson) {
        const detlist: Invdetlispre = {
          ENCLISPRE_NUMERO: isNullOrUndefined(numero) ? '' : numero,
          ART_CODIGO: iterator.ARTCODIGO,
          ART_NOMBRE: iterator.ARTNOMBRE,
          COM_CODIGO: '01',
          DETLISPRE_CODIGO: iterator.LISTACOD,
          DETLISPRE_COSTO: Number(iterator.COSTO).toFixed(this.invenclispreService.obtenerConfig('COSTO', 'MaePrecio')),
          DETLISPRE_DESCUENTO: Number(iterator.DESCUENTO).toFixed(2),
          DETLISPRE_PORCENTAJE: Number(iterator.UTILIDAD).toFixed(2),
          DETLISPRE_PRECIO: Number(iterator.PRECIO).toFixed(this.invenclispreService.obtenerConfig('PRECIO', 'MaePrecio')),
          LINEA: 0
        }
        this.invenclispreService.detlispre.push(detlist)
      }
      this.aggrid.refreshaggrid(this.invenclispreService.detlispre, this.defaultDetlispre.objeto);
      this.spin = false//CDPJ
      this.botonNuevo = true;
      this.botonGuardar = false;
      this.botonBorrar = true;
      this.botonRegresar = false;
    } catch (error) {
      this.messageService.add({
        key: 'invenclispre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al cargar los datos ' + error
      });
      this.spin = false//CDPJ
      return;
    }
  }
  changeTabs() { }
}
